import Navbar from '@/components/feature/Navbar';
import Footer from '@/pages/home/components/Footer';

const pillars = [
  { icon: 'ri-shield-check-line', title: 'Segurança jurídica', text: 'Cada negociação é conduzida com responsabilidade, clareza documental e atenção aos detalhes.' },
  { icon: 'ri-user-heart-line', title: 'Atendimento humano', text: 'Escutamos objetivos, entendemos contextos e acompanhamos cada cliente de forma próxima.' },
  { icon: 'ri-flashlight-line', title: 'Agilidade com tecnologia', text: 'Usamos recursos modernos para tornar jornadas complexas mais simples, rápidas e transparentes.' },
];

export default function QuemSomos() {
  return (
    <main className="min-h-screen bg-white">
      <Navbar />

      <section className="relative min-h-[520px] overflow-hidden">
        <img src="/quem-somos-hero.png" alt="Equipe BNI analisando um projeto imobiliário" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#061a35]/95 via-[#061a35]/75 to-transparent" />
        <div className="relative mx-auto flex min-h-[520px] items-center px-6 py-20 md:px-8">
          <div className="max-w-xl text-white">
            <span className="mb-5 inline-flex items-center gap-2 rounded-full border border-white/25 bg-white/10 px-4 py-2 text-xs font-bold uppercase tracking-[.18em] backdrop-blur-sm">
              <i className="ri-building-4-line text-primary-400" /> Quem somos
            </span>
            <h1 className="mb-5 text-4xl font-extrabold leading-tight md:text-6xl">BNI Negócios<br /><span className="text-primary-400">Imobiliários</span></h1>
            <p className="max-w-lg text-base leading-relaxed text-white/85 md:text-lg">Tradição imobiliária, transformação tecnológica e relações construídas com confiança.</p>
          </div>
        </div>
      </section>

      <section className="px-6 py-16 md:px-8 md:py-24">
        <div className="mx-auto grid items-center gap-12 lg:grid-cols-[1.1fr_.9fr]">
          <div>
            <span className="mb-3 block text-xs font-extrabold uppercase tracking-[.2em] text-primary-500">Nossa história</span>
            <h2 className="mb-6 text-3xl font-extrabold leading-tight text-secondary-950 md:text-4xl">Uma imobiliária preparada para o presente e para o futuro.</h2>
            <div className="space-y-5 text-base leading-8 text-slate-600">
              <p>Fundada em <strong className="text-secondary-950">10 de agosto de 2026</strong>, a BNI Negócios Imobiliários nasceu da união entre a solidez do mercado imobiliário tradicional e a velocidade da transformação tecnológica.</p>
              <p>Surgimos com o propósito claro de <strong className="text-secondary-950">descomplicar processos, humanizar o atendimento e garantir máxima segurança jurídica</strong> em cada transação.</p>
              <p>Acreditamos que um imóvel não é apenas uma estrutura física, mas o cenário onde histórias se constroem e patrimônios se consolidam.</p>
              <p>Por isso, trazemos ao mercado de 2026 uma metodologia ágil, transparente e focada em resultados reais para compradores, vendedores e investidores.</p>
            </div>
          </div>

          <div className="relative">
            <div className="absolute -left-5 -top-5 h-28 w-28 rounded-2xl bg-primary-500/10" />
            <img src="/quem-somos-seguranca.png" alt="Assinatura segura de uma negociação imobiliária" className="relative h-[440px] w-full rounded-2xl object-cover shadow-2xl" />
            <div className="absolute -bottom-6 left-6 rounded-xl bg-[#061a35] px-6 py-5 text-white shadow-xl">
              <strong className="block text-2xl font-extrabold text-primary-400">2026</strong>
              <span className="text-xs font-semibold uppercase tracking-wider">O início da nossa história</span>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 px-6 py-16 md:px-8 md:py-20">
        <div>
          <div className="mx-auto mb-12 max-w-2xl text-center">
            <span className="mb-3 block text-xs font-extrabold uppercase tracking-[.2em] text-primary-500">O que nos orienta</span>
            <h2 className="text-3xl font-extrabold text-secondary-950 md:text-4xl">Imóveis envolvem patrimônio.<br />Nosso trabalho envolve pessoas.</h2>
          </div>
          <div className="grid gap-6 md:grid-cols-3">
            {pillars.map((pillar) => (
              <article key={pillar.title} className="rounded-2xl border border-slate-200 bg-white p-8 text-center">
                <span className="mx-auto mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-primary-50 text-3xl text-primary-500"><i className={pillar.icon} /></span>
                <h3 className="mb-3 text-lg font-extrabold text-secondary-950">{pillar.title}</h3>
                <p className="text-sm leading-7 text-slate-600">{pillar.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-[#061a35] px-6 py-14 text-white md:px-8">
        <div className="mx-auto flex flex-col items-center justify-between gap-6 text-center md:flex-row md:text-left">
          <div><h2 className="mb-2 text-2xl font-extrabold md:text-3xl">Vamos construir seu próximo capítulo?</h2><p className="text-sm text-white/70">Converse com a BNI e encontre a oportunidade certa para você.</p></div>
          <a href="https://wa.me/554991950002" className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-7 py-4 text-sm font-bold text-white hover:bg-primary-600"><i className="ri-whatsapp-line text-xl" /> FALE CONOSCO</a>
        </div>
      </section>

      <Footer />
    </main>
  );
}
